import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from '@shared/apis';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Constants } from '@shared/constants/constants';

export interface ViewCountItem {
  videoId: string;
  videoTitle?: string;
  count: number;
}

@Component({
  selector: 'app-training-video-view-count-modal',
  templateUrl: './training-video-view-count-modal.component.html',
  styleUrls: ['./training-video-view-count-modal.component.scss'],
})
export class TrainingVideoViewCountModalComponent implements OnInit {
  startDate?: string | Date;
  endDate?: string | Date;
  userId?: any;
  isDealer?: boolean = false;

  viewCounts: ViewCountItem[] = [];
  loading = true;
  errorMessage: string | null = null;
  videoList = Constants.trainingVideos;

  constructor(
    public bsModalRef: BsModalRef,
    private apiService: ApiService,
  ) {}

  ngOnInit(): void {
    this.apiService.trainingVideo
      .getViewCounts(this.userId, this.startDate, this.endDate, this.isDealer)
      .pipe(
        catchError((err) => {
          console.error('[TrainingVideo] getViewCounts failed', err);
          this.errorMessage = 'Failed to load view counts.';
          return of([]);
        }),
      )
      .subscribe((data) => {
        this.loading = false;
        const raw = data as any;
        const list = Array.isArray(raw) ? raw : raw?.items ?? raw?.data ?? [];
        const countByVideoId = new Map<string, { videoTitle?: string; count: number }>();
        list.forEach((item: ViewCountItem) => {
          countByVideoId.set(item.videoId, {
            videoTitle: item.videoTitle,
            count: item.count ?? 0,
          });
        });
        const videoListOrdered = [...(this.videoList as readonly { index: number; title: string; route: string }[])]
          .sort((a, b) => a.index - b.index);
        this.viewCounts = videoListOrdered.map((v) => {
          const videoId = v.route.replace(/^video\//, '') || v.route;
          const fromApi = countByVideoId.get(videoId);
          return {
            videoId,
            videoTitle: v.title,
            count: fromApi?.count ?? 0,
          };
        });
      });
  }

  /** viewCounts 내 모든 item.count 합계 */
  get totalViewCount(): number {
    if (!this.viewCounts?.length) return 0;
    return this.viewCounts.reduce((sum, item) => sum + (item.count ?? 0), 0);
  }

  close(): void {
    this.bsModalRef.hide();
  }
}
